module.exports = __webpack_public_path__ + "static/media/adv_img_4.8a54b449.jpg";